/**
 * Interface for count config parameter type descriptors. These affect the behavior of the parameter card appearance on the Configurator.
 */
interface ICountConfigTypeDescriptor {
    min?: number;
    max?: number;
    default?: number;
    largeStep?: number;
    smallStep?: number;
}

export default ICountConfigTypeDescriptor;
